export default "__VITE_ASSET__DFcXc3uH__"